import request from '@utils/request'

export const state = {}

export const getters = {}

export const mutations = {}

export const actions = {
    export ({
        commit
    }, exportParams) {
        return request
            .post('/admin/order/export', exportParams)
            .then((response) => response.items)
    },
    simpleExport({
        commit
    }, exportParams) {
        return request
            .post('/admin/order/export/simple', exportParams)
            .then((response) => response.items)
    },
    verifyCodes({
        commit
    }, storeData) {
        return request.post('/admin/qrcode/verify', {
            ids: [...storeData]
        })
    },
    verifyCode({
        commit
    }, {
        codeId,
        verifyRule
    }) {
        return request.post(`admin/qrcode/${codeId}/verify`, verifyRule, {
            errorHandle: false,
        })
    },
    fetchSingleCode({
        commit
    }, codeId) {
        return request
            .get(`admin/qrcode/${codeId}`, {
                errorHandle: false
            })
            .then((response) => response.items)
    },
    sendLink({
        commit
    }, {
        orderId,
        router
    }) {
        return request.post(`admin/order/${orderId}/sendLink`, {
            router
        })
    },
    getLink({
        commit
    }, orderId) {
        return request.get(`admin/order/${orderId}/shortUrl`)
    },
    cancel({
        commit
    }, {
        orderId,
        cancelData
    }) {
        // orderId, note, refundValue
        return request.post(`admin/order/${orderId}/cancel`, cancelData)
    },
    store({
        commit
    }, storeData) {
        return request.post('/admin/order/store', storeData)
    },
    fetchSingle({
        commit
    }, orderId) {
        return request
            .get(`admin/order/${orderId}`)
            .then((response) => response.items)
    },
    fetchList({
        commit
    }, query) {
        return request
            .post('admin/order/search', query)
            .then(({
                items,
                productName,
                pagination: {
                    total
                }
            }) => {
                return {
                    items,
                    productName,
                    total
                }
            })
    },
    fetchInventoryList({
        commit
    }, query) {
        return request
            .post('admin/order/search', query)
            .then(({
                items,
                productName,
            }) => {
                return {
                    items,
                    productName,
                }
            })
    },
}
